import { Box, Typography, TextField, MenuItem } from "@mui/material";
import { useLocation } from "react-router-dom";
import { ResType } from "types";
import { useQuery } from "react-query";
import { getExcelEproceedingNotice } from "api/services/automation/income-tax-tan";
import { useEffect, useState } from "react";
import Table from "components/Table";
import { getAutFinancialYears } from "pages/atom-pro/constants";
import DateRange from "views/dashboard/OrgDashboard/DateRange";
import SearchContainer from "components/SearchContainer";

const intervalData = {
  today: 'today',
  last1week: "last 1 week",
  last15days: "last 15 days",
  last1month: "last 1 month",
  none: "All",
};

const nextIntervel = {
  today: "today",
  last1week: "Next 1 week",
  last15days: "Next 15 days",
  last1month: "Next 1 month",
  none: 'ALL'
  
};

const columnName = {
  noticeSentDate: "Notice Sent Date",
  dateOfCompliance: "Compliance Date",
  dateResponseSubmitted: "Submitted Date",
  all: "All",
};

const sortBy = {
  noticeSentDate: "Notice Sent Date",
  dateOfCompliance: "Compliance Date",
  dateResponseSubmitted: "Submitted Date",
  // all: "All"
};

const TempTanNoticesFilterPage = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [filters, setFilters] = useState<any>({
    itrType: null,
    filingType: null,
    assessmentYear: null,
    status: null,
    clientCategory: null,
    interval: null,
    column: null,
    sort: null,
  });
  const [dates, setDates] = useState({ fromDate: null, toDate: null });

  const { data, isLoading }: ResType = useQuery(
    [
      "get-fya-notices-excel",
      {
        search: search,
        limit: pageCount,
        offset: page * pageCount,
        ...dates,
        ...filters,
      },
    ],
    getExcelEproceedingNotice,
    {
      onSuccess: (res) => {
        setTotalCount(res?.data?.count);
      },
    }
  );

  const location = useLocation();
  const state: any = location.state;
  useEffect(() => {
    // setTimeout(() => {
    if (state?.column) {
      setFilters({
        ...filters,
        column: state?.column,
        interval: state?.interval,
        // assessmentYear: state?.assessmentYear,
      });
      setPage(0);
    }
    // }, 100)
  }, [state]);

  // const navigate = useNavigate()
  // const handleRowClick = (v: any) => {
  //     if (v.type === "fya") {
  //         navigate(`/atom-pro/income-tax/proceeding-action/notice-fya/${v?.id}`);
  //     } else {
  //         navigate(`/atom-pro/income-tax/proceeding-information/notice-fyi/${v?.id}`);
  //     }
  // };

  let columns = [
    {
      key: "ay",
      title: "AY",
      render: (row: any) => (
        <Typography sx={{ width: "70px" }}>{row?.ay === "0-01" ? "--" : row?.ay}</Typography>
      ),
    },
    {
      key: "eproType",
      title: "e-Pro Type",
    },
    {
      key: "",
      title: (
        <Box display="flex" alignItems="center">
          {/* <PersonOutlineOutlinedIcon style={{ width: "20px", marginRight: "5px" }} /> */}
          Name | TAN
        </Box>
      ),
      render: (row) => (
        <Typography>
          {row?.client?.displayName} (<span>{row?.pan}</span>)
        </Typography>
      ),
    },
    {
      key: "noticeDin",
      title: "DIN",
    },
    {
      key: "proceedingName",
      title: "Proceeding Name",
    },

    {
      key: "noticeSentDate",
      title: "Notice Sent Date",
      render: (row: any) => (
        <Typography>{row?.noticeSentDate ? row?.noticeSentDate : "--"}</Typography>
      ),
    },
    {
      key: "dateOfCompliance",
      title: "Date of Compliance",
      render: (row: any) => (
        <Typography>{row?.dateOfCompliance ? row?.dateOfCompliance : "--"}</Typography>
      ),
    },
    {
      key: "dateResponseSubmitted",
      title: "Date of Response Submitted",
      render: (row: any) => (
        <Typography>{row?.dateResponseSubmitted ? row?.dateResponseSubmitted : "--"}</Typography>
      ),
    },
    {
      key: "type",
      title: "Type",
      render: (row: any) => <Typography>{row?.type.toUpperCase()}</Typography>,
    },
  ];

  const handleAssessmentYearChange = (e: any) => {
    setFilters({ ...filters, assessmentYear: e.target.value });
    setPage(0);
  };

  const handleColumnChange = (e: any) => {
    setFilters({ ...filters, column: e.target.value });
    setPage(0);
  };

  const handleSortChange = (e: any) => {
    setFilters({ ...filters, sort: e.target.value });
    setPage(0);
  };

  const handleIntervalChange = (e: any) => {
    setFilters({ ...filters, interval: e.target.value });
    setPage(0);
    setDates({ fromDate: null, toDate: null });
  };
  useEffect(() => {
    if (dates.fromDate && dates.toDate) {
      setFilters({ ...filters, interval: "" });
    }
  }, [dates]);
  return (
    <Box m={1}>
      <Box display="flex" mb={1}>
        <SearchContainer
          minWidth="150px"
          debounced
          value={search}
          placeHolder="Search by Client Name | TAN "
          onChange={setSearch}
        />
        <Box ml={1}>
          <TextField
            name="assessmentYear"
            value={filters.assessmentYear || ""}
            onChange={handleAssessmentYearChange}
            size="small"
            label="Assessment Year"
            select
            sx={{ width: "150px", marginLeft: "5px" }}
          >
            <MenuItem key={""} value={""}>
              ALL
            </MenuItem>
            {getAutFinancialYears().map((year: string) => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box ml={1}>
          <TextField
            label="Interval"
            value={filters.interval || ""}
            sx={{ width: 150 }}
            onChange={handleIntervalChange}
            size="small"
            select
          >
            {Object.keys(intervalData).map((key, index) => (
              <MenuItem key={index} value={key}>
                {filters.column === "responseDueDate" ? nextIntervel[key] : intervalData[key]}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box ml={1}>
          <TextField
            label="Date Type"
            value={filters.column || ""}
            sx={{ width: 150 }}
            onChange={handleColumnChange}
            size="small"
            select
          >
            {Object.keys(columnName).map((key, index) => (
              <MenuItem key={index} value={key}>
                {columnName[key]}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box ml={1}>
          <TextField
            label="Sort By"
            value={filters.sort || ""}
            sx={{ width: 150 }}
            onChange={handleSortChange}
            size="small"
            select
          >
            {Object.keys(sortBy).map((key, index) => (
              <MenuItem key={index} value={key}>
                {sortBy[key]}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box ml={1}>
          <DateRange dates={dates} setDates={setDates} setPage={setPage} />
        </Box>
      </Box>
      <Table
        sx={{ pb: 0, mb: 0, height: "525px" }}
        pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
        data={data?.data.result || []}
        columns={columns}
        loading={isLoading}
        // onRowClick={handleRowClick}
      />
    </Box>
  );
};
export default TempTanNoticesFilterPage;
